import React, { useState, useImperativeHandle, forwardRef } from "react";

interface IPropsType {
    label: string,
    name: string,
    value?: string | number,
    type?: string,
    required: boolean,
    inputClass?: string,
    tooltipText?: string,
    placeholder?: string,
    additionalLabelClass?: string,
    additionalInputClass?: string,
    wrapInsideContainer?: boolean
    errorMessage?: string,
    allowOnlyNumbers?: boolean,
    allowOnlyDecimals?: boolean,
    defaultValue?: string,
    disabled?: boolean,
    className?: string,
    onChangeFun?: any
}


function textInput2(props: IPropsType, ref: any) {
    const stdLabelClass = 'field-label-16-roboto ';
    const stdInputClass = (!isValid && props.errorMessage ? " is-invalid" : "") + " form-control app-form-control";
    const [data, setData] = useState(props.value);
    const [isValid, setIsValid] = useState(true);

    useImperativeHandle(ref, () => ({

        validate() {
            setIsValid(true);
            console.log('textInput2 data=', data);
            if (props.required && data.toString().trim().length == 0) {
                setIsValid(false);
                return false;
            }
            return true;
        },

        getData() {
            if (data) {
                if (data.length == 0 && (props.allowOnlyDecimals || props.allowOnlyNumbers))
                    return 0;
                else return data;
            }
            else if (props.allowOnlyDecimals || props.allowOnlyNumbers)
                return 0;
            else return data;
        }
    }));

    const inputComponent = (<input disabled={props.disabled} type={props.type ? props.type : "text"}
        {...
        (data && { value: data })
        }
        name={props.name}
        /*value={props.value}*/
        defaultValue={props.defaultValue}
        
        onChange={(e) => {
            const numRegex = /^[0-9\b]+$/;
            const decimalRegex = /^\d*\.?\d*$/;

            props?.onChangeFun?.(e.target.value.trim().split('').filter(i => !isNaN(Number(i))).join(""));

            if (!props.allowOnlyNumbers && !props.allowOnlyDecimals) {
                setData(e.target.value);
            }

            else {
                if (props.allowOnlyNumbers && (e.target.value === '' || numRegex.test(e.target.value))) {
                    setData(e.target.value);
                }

                else if (props.allowOnlyDecimals && (e.target.value === '' || decimalRegex.test(e.target.value))) {
                    setData(e.target.value);
                }
                else {
                    e.target.value = null;
                    //setData(e.target.value);
                }

            }

        }}
        required={props.required}
        className={(props.inputClass ? props.inputClass : ((!isValid && props.errorMessage ? "is-invalid" : "")))}
        placeholder={props.placeholder}
    />);

    const errorComponent = (<React.Fragment>{!isValid && props.errorMessage && <p className={"errorText" + (props.wrapInsideContainer ? " always-block" : "")}>{props.errorMessage}</p>}</React.Fragment>);

    if (props.wrapInsideContainer) {
        return (
            <React.Fragment>
                <div className={`inputWrapper ${props.className}`}>
                    {props.label && <span>{props.label}</span>}
                    {inputComponent}
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className={`inputWrapper ${props.className}`}>
                {props.label && <span>{props.label}</span>}
                {inputComponent}
                {errorComponent}
            </div>
        </React.Fragment>
    );


}

export default textInput2 = forwardRef(textInput2);
